const ConselhosPermitidos = [
    { sigla: 'CRM', nome: 'CRM(Conselho Regional de Medicina)' },
    { sigla: 'CRESS', nome: 'CRESS(Conselho Regional de Serviço Social)' },
    { sigla: 'COREN', nome: 'COREN(Conselho Regional de Enfermagem)' },
    { sigla: 'CRF', nome: 'CRF(Conselho Regional de Farmácia)' },
    { sigla: 'CREFONO', nome: 'CREFONO(Conselho Regional de Fonoaudiologia)' },
    { sigla: 'CREFITO', nome: 'CREFITO(Conselho Regional de Fisioterapia e Terapia Ocupacional)' },
    { sigla: 'CRN', nome: 'CRN(Conselho Regional de Nutrição)' },
    { sigla: 'CRO', nome: 'CRO(Conselho Regional de Odontologia)' },
    { sigla: 'CRP', nome: 'CRP(Conselho Regional de Psicologia)' },
    { sigla: 'CRBio', nome: 'CRBio(Conselho Regional de Biologia)' },
    { sigla: 'CRBM', nome: 'CRBM(Conselho Regional de Biomedicina)' },
    { sigla: 'CREF', nome: 'CREF(Conselho Regional de Educação Física)' },
    { sigla: 'CRMV', nome: 'CRMV(Conselho Regional de Medicina Veterinária)' },
    { sigla: 'CRTR', nome: 'CRTR(Conselho Regional de Técnicos em Radiologia)' }
];
  
export default ConselhosPermitidos;
  